import { ChannelkartNetworkGet } from "./networkService";

export async function getUserData(loginid: String) {
    const response = await ChannelkartNetworkGet(`/users?filter=loginId:${loginid}`);
    return response.data;
}
export async function getDeliveryPJP(loginid: String) {
    const response = await ChannelkartNetworkGet(`/deliveryPJP?loginid=${loginid}`);
    return response.data;
}
export async function getSchemeDef(schemeId: String) {
    const response = await ChannelkartNetworkGet(`/fetchSchemeDefination?schemeId=${schemeId}`);
    return response.data;
}
export async function getSchemeCal(schemeId: String) {
    const response = await ChannelkartNetworkGet(`/fetchSchemeCalculation?schemeId=${schemeId}`);
    return response.data;
}
export async function getSchemeMustBuy(schemeId: String) {
    const response = await ChannelkartNetworkGet(`/fetchMustBuyGroup?schemeId=${schemeId}`);
    return response.data;
}
export async function getSchemeOutBif(schemeId: String) {
    const response = await ChannelkartNetworkGet(`/fetchOutletBifurcations?schemeId=${schemeId}`);
    return response.data;
}
export async function getSchemeProBif(schemeId: String) {
    const response = await ChannelkartNetworkGet(`/fetchProductBifurcations?schemeId=${schemeId}`);
    return response.data;
}



export async function getDistinctOutlets(loginid: String) {
    const response = await ChannelkartNetworkGet(`/distinctOutlets?filter=hierarchy[match]:${loginid}`);
    return response.data;
}

export async function getOutletData(outletcode: string){
    const response = await ChannelkartNetworkGet(`/outletDetails/outletcode/${outletcode}`);
    return response.data;
}

export async function getProductDataUsingSkucode(skucode: String) {
    const response = await ChannelkartNetworkGet(`/products?filter=skuCode:${skucode}`);
    return response.data;
}
export async function getStockData(skucode: String) {
    const response = await ChannelkartNetworkGet(`/stockBySKU?sku=${skucode}`);
    return response.data;
}

export async function getProductDataUsingBatchcode(batchcode: String) {
    const response = await ChannelkartNetworkGet(`/products?filter=batchCode:${batchcode}`);
    return response.data;
}

export async function getProductMetadata(skucode: String) {
    const response = await ChannelkartNetworkGet(`/productmetadata/v1/itemsBySKU?skuCode=${skucode}`);
    return response.data;
}
export async function getProductInfo(loginId: String) {
    const response = await ChannelkartNetworkGet(`/outletProductInfo?filter=outletCode:${loginId}`);
    return response.data;
}

export async function getAnalytics(loginid: String) {
    const response = await ChannelkartNetworkGet(`/v1/analytics?userName=${loginid}`);
    return response.data;
}

export async function getAttendance(loginid: string){
    const response = await ChannelkartNetworkGet(`/attendance?filter=hierarchy[match]:${loginid}`)
    return response.data;
}

export async function getDistinctNameFromGenericObject(){
    const response = await ChannelkartNetworkGet(`/getDistinctNames`);
    return response.data;
}

export async function getInvoiceCollection(loginid: string){
    const response = await ChannelkartNetworkGet(`/v1/invoiceCollection?filter=loginid:${loginid}`);
    return response.data;
}

export async function getOrdersData(startDate: string, endDate: string, loginid: string){
    const response = await ChannelkartNetworkGet(`/v2/orders?sort=creationTime:desc&filter=loginId:${loginid} and creationTime[gte]:${startDate} and creationTime[lte]:${endDate} and type[nin]:[Tertiary]`);
    return response.data;
}
export async function getSalesData(startDate: string, endDate: string, loginid: string){
const response = await ChannelkartNetworkGet(`/v3/sales?includeSalesDetails=true&filter=${encodeURIComponent(`loginId:${loginid} and creationTime[gte]:${startDate} and creationTime[lte]:${endDate}`)}`);
    return response.data;
}

export async function getEnrichmentInfo(){
const response = await ChannelkartNetworkGet('/v1/enrichments');
    return response.data;
}

export async function getTransformerInfo(){
const response = await ChannelkartNetworkGet('/v1/transformers');
    return response.data;
}
export async function getQueryInfo(){
const response = await ChannelkartNetworkGet('/v1/query/info');
    return response.data;
}

export async function getGenericObjectData(name: string){
    const response = await ChannelkartNetworkGet(`/models/name/${name}`);
    return response.data;
}

export async function getDistinctNames(){
    const response = await ChannelkartNetworkGet(`/v1/query/distinctNamesGenericObject`);
    return response.data;
}